import React from 'react';

import { StyledCountryWithFlag } from './CountryWithFlag.styles';

import { CountryWithFlagProps } from './CountryWithFlag.types';

import { Flag } from '../';

//TODO Remove Duplicate "className" prop (duplicate of "customClassnames")
const CountryWithFlag = ({
  country,
  round,
  height = 20,
  className,
  componentClassname = 'country-with-flag',
  customClassnames = '',
  customStyle = '',
}: CountryWithFlagProps) => {
  return (
    <StyledCountryWithFlag
      className={`${componentClassname} ${customClassnames} ${className}`}
      customStyle={customStyle}
    >
      <Flag
        className={`${componentClassname}__flag`}
        country={country.code}
        round={round}
        height={height}
      />
      <div className={`${componentClassname}__name`}>{country.name}</div>
    </StyledCountryWithFlag>
  );
};
CountryWithFlag.displayName = 'CountryWithFlag';

export default CountryWithFlag;
